import { IEnvConfig } from 'interfaces/i-env-config';
import { LoginMethod } from 'lib_ts/enums/auth.enums';
import { LanguageCode } from 'lib_ts/enums/translation';

export const ENV_DEV: IEnvConfig = {
  identifier: 'dev',
  maintenance: false,
  strict: true,
  use_radix: true,

  production: false,
  languages: [LanguageCode.English, LanguageCode.Japanese, LanguageCode.Korean],

  debug_messages: true,
  region_redirect: true,
  run_tests: false,

  self_url: 'https://dev.trajektsports.app',
  server_url: 'https://dev.trajektsports.app/node',
  ws_url: 'https://dev.trajektsports.app/users',
  ws_path: '/socket.io/',

  login_methods: [LoginMethod.Auth0, LoginMethod.Legacy],

  liveboard_url: 'https://deploy-dev.d1tkhsszyqq0g1.amplifyapp.com',

  enable: {
    change_language: true,

    vitals: false,

    sample_lists: false,

    toggle_rapid: true,

    pitch_upload_avg_release: true,
    pitch_upload_avg_chars: false,

    toggle_plate_shots: false,
    toggle_plate_debug: true,
    toggle_plate_safety_controls: true,
    toggle_plate_ellipses: true,
  },

  integrations: {
    intercom_app_id: 'tas54ol3',

    auth0: {
      domain: 'trajektsports.us.auth0.com',
      audience: 'https://trajektsports.us.auth0.com/api/v2/',
      clientId: 'RxQ4CrNi3VNfb4xk60Z0dn6SYp6wolAC',
    },

    sentry: {
      enabled: false,
      dsn: 'https://d788b74980a6ee68987343d048d92b41@o4509952079429632.ingest.us.sentry.io/4509967840378880',
      environment: 'development',
      trace_sample_rate: 0,
    },
  },
};
